<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div class="title">我的消息</div>
    <div class="line"></div>
    <el-empty description="暂无消息" v-if="currentitems.length == 0" style="margin: 0 auto;"></el-empty>

    <div class="box" v-for="item in this.currentitems">
      <img src="../../assets/logo1.png" alt="" class="touxiang">
      <img src="../../assets/new.png" v-if="item.isRead == 1" alt="" class="new">

      <div class="txt">{{ item.infoOne }}</div>
    </div>
    <div class="pagination" v-if="currentitems.length !== 0">
      <!-- <div class="first" @click="pageindex = 1">首页</div> -->
      <el-pagination layout="prev, pager, next" :total="parseInt(this.total)" :page-size="4"
        :current-page="parseInt(pageindex)" :pager-count="7" @current-change="change" :key="pageindex">
      </el-pagination>
      <!-- <div class=" first" @click="pageindex = totalpages">尾页
      </div> -->
      <div class="txt">前往</div>
      <input type="text" v-model.lazy="pageindex">
      <div class="txt2">页</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageindex: 1,
      currentitems: [],
      total: 0
    }
  },
  computed: {
    totalpages() {
      return Math.ceil(parseInt(this.total) / 4)
    }


  },
  methods: {
    change(index) {
      this.pageindex = index
    }
  },
  created() {
    this.$http.get('/Api/Parent/Messages', {
      params: {
        pageNumber: 1,
        pageSize: 4,
      },
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      console.log(res.data.data)
      this.currentitems = res.data.data.records
      this.currentitems.forEach(item => {
        this.$http.post('/Api/User/Read/' + item.mid, {}, {
          headers: {
            'Authorization': this.Authorization
          }
        }).then(res => {
          console.log(res)
        })
      })
      this.total = res.data.data.total
    })
  },

  watch: {
    pageindex(n, o) {
      if (n !== o) {
        if (isNaN(parseInt(n))) {
          this.$message({
            message: '请输入数字',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        else if (n > Math.ceil(parseInt(this.total) / 4) || n < 1) {
          this.$message({
            message: '您输入的范围不对哦~~',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        this.$http.get('/Api/Parent/Messages', {
          params: {
            pageNumber: n,
            pageSize: 4
          },
          headers: {
            'Authorization': localStorage.getItem('Authorization')
          }

        }).then(res => {
          console.log(res.data.data)
          this.currentitems = res.data.data.records
          // this.total = res.data.data.total
        })
      }

    }
  }

}
</script>

<style  scoped>
/deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(255, 255, 255);
}

/deep/ .el-pager .number {
  /* 页1 */
  width: 35px;
  height: 35px;
  border-radius: 4px;
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 5.5px;
  margin-right: 5.5px;
  background: rgb(240, 242, 245);
  color: rgb(96, 98, 102);
}

/deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(255, 255, 255);
}

/deep/ .el-pagination button {
  /* 上一页 */
  height: 35px;
  background: rgb(245, 245, 245);
  border-radius: 4px;
  color: rgb(0, 0, 0);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  padding: 0 !important;

}

/* .total /deep/ .el-pagination button,
  .total /deep/ .el-pagination li {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  } */

.first,
/deep/ .pagination input {
  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
  margin-top: 3px;
}

/deep/ .el-pagination .more {
  /* box-shadow: none !important; */
  /* color: rgb(1, 162, 153); */
  /* margin-top: 5px; */
  background: rgb(240, 242, 245);
  width: 32px;
  height: 35px;
  border-radius:
    2px;
  /* font-size: 30px; */
  padding-top: 3px;
}

.pagination {
  margin-top: 100px;
  display: flex;
  width: 700PX;
  height: 100px;
  justify-content: center;
  gap: 11px
}

.pagination .first {
  width: 46px;
  height: 35px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  /* 首页 */
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
}

.pagination .txt {
  /* 共 5 页 前往 */
  width: 40px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
  transform: translateX(10px);
}

.pagination input {
  /* 选页 */
  width: 60px;
  height: 35px;
  background: rgb(255, 255, 255);
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  text-align: center;
}

.pagination .txt2 {
  /* 页 */
  width: 15px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;

}

.title {
  /* 修改手机号 */
  /* 我的消息 */
  height: 32px;
  color: rgb(0, 0, 0);
  font-family: 微软雅黑;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;

}

.line {
  /* Line */
  width: 750px;
  height: 2px;
  background: rgb(220, 223, 230);
  margin-top: 16px;
}

.box {
  display: flex;
  height: 128px;
  width: 700px;
  margin-left: 22px;
  margin-top: 21px;
  margin-bottom: 10px;
  position: relative;

}

.box .touxiang {
  width: 63px;
  height: 84px;
  margin-top: 22px;
  z-index: 0;
}

.box .new {
  width: 30px;
  height: 45px;
  position: absolute;
  top: 5px;
  z-index: 1;
  left: 50px;
}

.box .txt {
  width: 637px;
  height: 128px;
  background: url('../../assets/messagebg.png') center;
  background-size: 100% 100%;

  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  padding: 20px 25px 20px 35px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/studentmessage.vue